import { render, staticRenderFns } from "./TemplatesList.vue?vue&type=template&id=1dac14a1&scoped=true"
import script from "./TemplatesList.vue?vue&type=script&lang=js"
export * from "./TemplatesList.vue?vue&type=script&lang=js"
import style0 from "./TemplatesList.vue?vue&type=style&index=0&id=1dac14a1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dac14a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dac14a1')) {
      api.createRecord('1dac14a1', component.options)
    } else {
      api.reload('1dac14a1', component.options)
    }
    module.hot.accept("./TemplatesList.vue?vue&type=template&id=1dac14a1&scoped=true", function () {
      api.rerender('1dac14a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/TemplatesList.vue"
export default component.exports